<!-- SI NO TE ASSIGNAT UN AGENT I UUIDQR, EL QR ET PORTA A LA LLISTA DE QRs D'UNA PHASE. SI TE AGENT, ET PORTA A LA PANTALLA DE GESTIÓ EXTERNA DEL CMR PER UNA PHASE (shared.cmr.agent.qr.page) -->
<div *ngIf="phaseUUID">
    <div *ngIf="formatDocumentQRCode" class="codeqr" (click)="onClickQR()">
        <div class="img"><img [src]="formatDocumentQRCode" /></div>
        <div class="help-qr">{{ helpResource | translate }}</div>
    </div>
</div>
